<template>
  <div id="award">
    <div class="introTitle">
      竞赛荣誉
    </div>


    <el-row :gutter="20">
      <el-col :span="8">
        <img
            width="100%"
          src="@/assets/img/meeting and award/2023无人飞行器智能感知技术竞赛.jpg"
        />
        <div class="imgIntro">2023年，“智在飞翔” 无人飞行器智能感知技术竞赛，一等奖</div>
        <br />
      </el-col>
      <el-col :span="8">
        <img
            width="100%"
          src="@/assets/img/meeting and award/国家遥感中心无人机遥感比测.jpg"
        />
        <div class="imgIntro">
          2023年，科学技术部国家遥感中心第二届无人机遥感比测，一等奖
        </div>
        <br />
      </el-col>
      <el-col :span="8">
        <img
            width="100%"
          src="@/assets/img/meeting and award/2023第二届烽火杯目标智能识别大赛.jpg"
        />
        <div class="imgIntro">
          2023年，第二届烽火杯目标智能识别大赛，一等奖
        </div>
        <br />
      </el-col>
    </el-row>

    
    <el-row :gutter="20">
      <el-col :span="8">
        <img
            width="100%"
          src="@/assets/img/meeting and award/竞赛-1.png"
        />
        <div class="imgIntro">2017年，高分无人机决赛，二等奖</div>
        <br />
      </el-col>
      <el-col :span="8">
        <img
            width="100%"
          src="@/assets/img/meeting and award/竞赛-2.png"
        />
        <div class="imgIntro">
          2018年，高分无人机智能感知竞赛现场赛，三等奖
        </div>
        <br />
      </el-col>
      <el-col :span="8">
        <img
            width="100%"
          src="@/assets/img/meeting and award/竞赛-3.jpg"
        />
        <div class="imgIntro">
          2020年，高分北斗无人飞行器智能感知技术竞赛，一等奖
        </div>
        <br />
      </el-col>
    </el-row>
    <img width="100%" src="@/assets/img/meeting and award/竞赛-4.png" />
    <div class="imgIntro">
      2020年，风云卫星算法大赛，二等奖
    </div>
    <div class="introTitle">
      国家奖学金及学术荣誉
    </div>
    <img width="100%" src="@/assets/img/meeting and award/奖励-1.jpg" />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang='less' scoped>
#award {
  .introTitle{
    height: 36px;
    line-height: 36px;
    padding-left: 10px;
    font-weight: bolder;
    color: #076498;
    border-bottom: 1px solid #b1b1b1;
    margin-bottom: 10px;
  }
  .imgIntro{
    font-size: 14px;
    color: #4f4f4f;
    text-align: center;
  }
  .describe_1 {
    // font-family: "Times New Roman", Times, serif;
    margin-left: 10px;
    margin-right: 5px;
  }
  // .describe_2 {
  //   // font-family: "Times New Roman", Times, serif;
  //   // margin-left: 0px;
  //   // margin-right: 0px;
  // }
  .describe_3 {
    // font-family: "Times New Roman", Times, serif;
    text-align: center;
  }
}
</style>
